import {
  createClient,
  i18n,
  AuthProvider,
  AnalyticsProvider,
  captureObservabilityError,
  DebugLoggingProvider,
} from '@psyomics/ui-common';
import { BackgroundProvider, BreadcrumbProvider, DebugLogs, GenericError } from '@psyomics/ui-components';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Provider as UrqlProvider } from 'urql';

import { getConfig } from '../config';

import { AuthRoutes } from './auth-routes';

const config = getConfig();

export const renderRoot = () => {
  const htmlElement = document.getElementById('root');

  if (!htmlElement) {
    throw new Error('no root dom element');
  }

  const root = ReactDOM.createRoot(htmlElement);
  const { referralApiUrl, referralApiClientId, referralApiCognitoDomain, postHogApiKey, postHogHost } = config;

  root.render(
    <StrictMode>
      <DebugLoggingProvider enabled={config.debugLogsEnabled}>
        <>
          <AnalyticsProvider apiKey={postHogApiKey} host={postHogHost}>
            <BrowserRouter>
              <BackgroundProvider>
                <ErrorBoundary fallback={<GenericError />} onError={captureObservabilityError}>
                  <I18nextProvider i18n={i18n}>
                    <AuthProvider
                      apiUrl={referralApiUrl}
                      clientId={referralApiClientId}
                      cognitoDomain={referralApiCognitoDomain}
                    >
                      <UrqlProvider value={createClient(`${referralApiUrl}/graphql`)}>
                        <BreadcrumbProvider>
                          <AuthRoutes />
                        </BreadcrumbProvider>
                      </UrqlProvider>
                    </AuthProvider>
                  </I18nextProvider>
                </ErrorBoundary>
              </BackgroundProvider>
            </BrowserRouter>
          </AnalyticsProvider>
          <DebugLogs />
        </>
      </DebugLoggingProvider>
    </StrictMode>
  );
};
